import styled, { css } from 'styled-components'
import { SpinnerProps } from './Spinner.types'
import Flex from '../Flex'

const getEmptyBorder = (emptyColor: string) => {
  if (emptyColor) {
    return css`
      border-top: 2px solid ${emptyColor};
      border-right: 2px solid ${emptyColor};
    `
  }
  return css`
    border-top: 2px solid transparent;
    border-right: 2px solid transparent;
  `
}

export const StyledSpinner = styled(Flex)<SpinnerProps>`
  border: 2px solid ${(props) => props.color};
  ${(props) => getEmptyBorder(props.emptyColor)}
  animation: roll 1s linear infinite;
  aspect-ratio: 1;

  @keyframes roll {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`
